import Constants from '@/Constants';
import { BadgeTranslation } from '@/models/BadgeTranslation';
import { PersonBadge } from '@/models/PersonBadge';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    personBadge: PersonBadge;
}

type AchievementType = 'Badge' | 'Token';

const AchievementCarouselItem: React.FC<Props> = ({ personBadge }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const [currentBadgeTranslation, setCurrentBadgeTranslation] = useState<BadgeTranslation>();

    const { badge } = personBadge;

    const { badgeTranslations } = badge;

    const achievementType: AchievementType = badge.isToken ? 'Token' : 'Badge';

    const getImage = (): string => {
        const path = Constants.imageFolders.STATIC_ASSETS_BADGES.replace('%k', badge.key);
        return `${path}${Constants.badgeImages.THUMB}`;
    };

    useEffect(() => {
        if (badgeTranslations) {
            setCurrentBadgeTranslation(badgeTranslations.find((bt: BadgeTranslation) => bt.locale === strings._LANGUAGE));
        }
    }, [strings._LANGUAGE, badgeTranslations]);

    return (
        <>
            {badge && currentBadgeTranslation && (
                <div className="achievement">
                    <img alt={currentBadgeTranslation.name} className="achievement__image" src={getImage()} />
                    <div>
                        <span>{achievementType}</span>
                        <strong>{currentBadgeTranslation.name}</strong>
                    </div>
                </div>
            )}
        </>
    );
};

export default AchievementCarouselItem;
